import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette }) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    height: spacing(75),
    width: '100%',
    paddingLeft: spacing(71),
    borderBottom: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
  },
  headerButtons: {
    display: 'flex',
    gap: '8px',
  },
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    padding: '32px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '2.5rem',
    gap: '3rem',
  },
  row: {
    display: 'flex',
    gap: '2rem',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '0.5rem',
    marginTop: '10px',
    flex: 1,
  },
  editIcon: {
    width: spacing(12),
    height: spacing(12),
    color: 'white',
    fill: 'white',
  },
  switchLabel: {
    color: palette.gray[64],
    marginBottom: spacing(6),
    fontSize: spacing(12),
    width: 'max-content',
    display: 'block',
    marginTop: spacing(10),
  },
  accordion: {
    display: 'grid',
  },
  accordionGap: {
    marginTop: spacing(24),
    columnGap: spacing(16),
    rowGap: spacing(20),
  },
  cepContainer: {
    height: '32px !important',
  },
  cepLabel: {
    gap: '0px !important',
  },
  editContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '1rem',
  },
  button: {
    width: spacing(154),
    height: spacing(40),
    fontWeight: 'normal',
    fontSize: spacing(15),
    whiteSpace: 'nowrap',
  },
  unitsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  wrapper: {
    borderBottom: `${spacing(1)} solid #E3E3E3`,
    width: '100%',
  },
  details: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '2rem',
    width: '100%',

    '&:hover': {
      backgroundColor: '#F5F5F5',
      // cursor: 'pointer',
    },
  },
  unitDetails: {
    display: 'flex',
    width: '80%',
    maxWidth: '1200px',
  },
  userList: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    '& :last-of-type': {
      borderBottom: 'none',
    },
  },
  title: {
    color: palette.gray[32],
    marginTop: spacing(6),
  },
  icon: {
    color: palette.gray[32],
  },
  select: {
    width: '100%',
    margin: 0,
    height: '100% !important',

    '& .MuiFormLabel-root': {
      fontSize: `${spacing(16)} !important`,
      color: palette.gray[64],
    },

    '& .MuiFormHelperText-root': {
      display: 'none',
    },
  },
  tooltipIcon: {
    fontSize: '2rem',
    fontWeight: '500',
    lineHeight: '2.4rem',
    fill: palette.gray[64],
    margin: 0,
  },
  cpfCnpjField: {
    '& label': {
      fontSize: '1.2rem !important',
      color: palette.gray[64],
    },
    '& .r__MaskInput-ErrorMessage': {
      bottom: '-20px',
    },
  },
}))
